// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"18357": "70fb16f8c80d","25959": "ee099f1813f6","27413": "d148d0329813","39200": "44155b8ad8ac","43644": "5f8b6501f54b","66863": "c939bdd77392","71607": "0a72330dcf49","79507": "b629845104c8","91447": "cef096c99799",}[chunkId] + ".css"
}